import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { SessionStore } from '../stores/session.store';
import { AutoUnsubscribe } from '@ildes/abstracts/auto-unsubscribe.component';

const AND = 'AND';
const OR = 'OR';
@Directive({
  selector: '[allowAction]',
  standalone: true,
})
export class AllowActionDirective extends AutoUnsubscribe implements OnInit {

  @Input('allowAction') action;
  @Input('config') config = 'hideIfNotCompliance';
  @Input('evaluationMode') evaluationMode = AND;
  constructor(
    public el: ElementRef
  ) {
    super();
  }

  ngOnInit(): void {
    const sessionStore = SessionStore.getInstance();

    const sub = SessionStore.getInstance().get$().subscribe((data) => {
      if (!data?.user) {

        return;
      }
      const currentStyle = this.el.nativeElement.style.display;
      if (this.config !== 'showWhenNotCompliance') {
        this.el.nativeElement.style.display = this.hasPermission(data.user, this.action, this.evaluationMode) ? currentStyle : 'none';
      } else {
        this.el.nativeElement.style.display = this.hasPermission(data.user, this.action, this.evaluationMode) ? 'none' : currentStyle;
      }

    });
    this.addSubscription(sub);
  }

  // private hasPermission(user, action){
  //   const [family, actionName] = action;
  //
  //   return user.permissions[family]&&user.permissions[family][actionName];
  // }

  private hasPermission(user, action, evaluationMode){
    return action.reduce((result, currentAction) => {
      const [family, actionName] = currentAction.split('.');

      if (evaluationMode === AND) {
        return result && (user.permissions[family] && user.permissions[family][actionName]);
      }
      return result || (user.permissions[family] && user.permissions[family][actionName]);
    }, evaluationMode === AND);
  }
}
